<template>
    <div>
        <breadcrumb :routerList="[{to:'/chanp/productBom',title:'套餐管理'},{title:'新增套餐'}]"/>
        <div class="bigDiv">
            <div class="h-piece">
                <div>
                    <div class="h-pieceTitle2" style="margin-bottom: 0.4rem;">
                        <h1>套餐主体</h1>
                    </div>
                    <div class="pieceCon n-bu">
                        <div class="h-pieceCon2">
                            <el-form :model="f" label-position="right" ref="f" :inline="true" :rules="rules"
                                         class="demo-ruleForm h-formbLine h-formbLine1">
                                    <div class="h-rowCon1 Bianji">
                                        <el-form-item label="套餐类型" class="h-elformWrap-2">
                                            <brselect placeholder="请选择"
                                                      category="package_type"
                                                      :disabled="isShouh"
                                                      :v="f.packageType"
                                                      clearable
                                                      @change="changePackage"
                                                      v-model="f.packageType">
                                            </brselect>
                                        </el-form-item>
                                        <el-form-item label="链群" class="h-elformWrap-2" v-if="!isShouh">
                                            <brselect placeholder="请选择"
                                                      category="xsyb_lianqun"
                                                      :v="f.lianqunCode"
                                                      clearable
                                                      v-model="f.lianqunCode">
                                            </brselect>
                                        </el-form-item>
                                        <el-form-item label="链群" class="h-elformWrap-2" v-if="isShouh">
                                            <el-input disabled v-model="f.lianqunName"></el-input>
                                        </el-form-item>
                                        <el-form-item label="场景" class="h-elformWrap-2" v-if="this.showSence">
                                            <el-input disabled v-model="f.sceneName"></el-input>
                                        </el-form-item>
                                        <el-form-item label="子场景" class="h-elformWrap-2" v-if="this.showChildSence">
                                            <brselect category="package_lk_childScene" :v="f.childSceneCode" :showcode="true"
                                                      v-model="f.childSceneCode" ></brselect>
                                        </el-form-item>
                                        <el-form-item label="套餐描述" class="h-elformWrap-2" prop="packageName">
                                            <el-input placeholder="请输入套餐描述" v-model="f.packageName"></el-input>
                                        </el-form-item>
                                        <el-form-item label="是否整单发货" class="h-elformWrap-2" prop="isTj">
                                            <el-select v-model="f.isWhole" placeholder="请选择">
                                                <el-option label="否" value="0"></el-option>
                                                <el-option label="是" value="1"></el-option>
                                            </el-select>
                                        </el-form-item>
                                        <el-form-item label="是否计入场景收入" class="h-elformWrap-2" prop="isTj">
                                            <el-select v-model="f.isSceneIncome" placeholder="请选择">
                                                <el-option label="否" value="0"></el-option>
                                                <el-option label="是" value="1"></el-option>
                                            </el-select>
                                        </el-form-item>
                                        <el-form-item label="是否允许单品销售" class="h-elformWrap-2" prop="isTj">
                                            <el-select v-model="f.isSingleSale" placeholder="请选择">
                                                <el-option label="否" value="0"></el-option>
                                                <el-option label="是" value="1"></el-option>
                                            </el-select>
                                        </el-form-item>
                                        <el-form-item label="税率" class="h-elformWrap-2" prop="isTj">
                                            <el-select v-model="f.shuilv" placeholder="请选择">
                                                <el-option label="6%" value="JQ"></el-option>
                                                <el-option label="9%" value="J5"></el-option>
                                                <el-option label="13%" value="JC"></el-option>
                                            </el-select>
                                        </el-form-item>
                       <!--                 <el-form-item label="税分类编码" class="h-elformWrap-2" prop="taxcode">
                                            <el-input placeholder="请输入税分类编码" v-model="f.taxCode" ></el-input>
                                        </el-form-item>-->
                                        <el-form-item label="税分类编码" class="h-elformWrap-2" prop="taxCode">
                                            <el-select v-model="f.taxCode" remote
                                                       filterable :filter-method="getTaxcodeList" @change="" :v="f.taxCode" clearable filterable placeholder="请输入"
                                                       :remote-method="getTaxcodeList" >
                                                <el-option v-for="(item) in taxList"
                                                           :key="item.key"
                                                           :label="item.value"
                                                           :value="item.key">
                                                </el-option>
                                            </el-select>
                                        </el-form-item>
                                        <el-form-item label="是否中转" class="h-elformWrap-2" prop="isTransit">
                                            <el-select v-model="f.isTransit" @change="changeTransit" placeholder="请选择">
                                                <el-option label="否" value="0"></el-option>
                                                <el-option label="是" value="1"></el-option>
                                            </el-select>
                                        </el-form-item>
                                        <el-form-item label="选择收货地址"
                                                      readonly
                                                      v-if="showTransit"
                                                      prop="address" class="h-elformWrap-2">
                                            <el-input clearable v-model="f.address" readonly style="width:100%;">
                                                <i
                                                        class="el-icon-search el-input__icon"
                                                        slot="suffix"
                                                        @click="selectAreadialog">
                                                </i>
                                            </el-input>
                                        </el-form-item>
                                        <el-form-item label="联系人" class="h-elformWrap-2" v-if="showTransit" prop="contactPerson">
                                            <el-input placeholder="请输入联系人" v-model="f.contactPerson"></el-input>
                                        </el-form-item>
                                        <el-form-item label="联系方式" class="h-elformWrap-2" v-if="showTransit" prop="phone">
                                            <el-input placeholder="请输入联系方式" v-model="f.phone"></el-input>
                                        </el-form-item>

                                        <el-form-item label="套餐价格" class="h-elformWrap-2" prop="packagePrice">
                                            <el-input v-model="f.packagePrice"  disabled></el-input>
                                        </el-form-item>

                                        <el-form-item label="套餐开始时间" class="h-elformWrap-2">
                                            <el-date-picker
                                                    placeholder="请选择"
                                                    v-model="f.startTime"
                                                    :clearable="false"
                                                    type="date"
                                                    value-format="yyyy-MM-dd" >
                                            </el-date-picker>
                                        </el-form-item>
                                        <el-form-item label="套餐结束时间" class="h-elformWrap-2">
                                            <el-date-picker
                                                    placeholder="请选择"
                                                    v-model="f.endTime"
                                                    :clearable="false"
                                                    type="date"
                                                    value-format="yyyy-MM-dd" >
                                            </el-date-picker>
                                        </el-form-item>
                                        <el-form-item label=" 指定经销商" prop="agentName" v-if="showTj" class="h-elformWrap-2" >
                                            <el-select v-model="f.agentCode" remote filterable :filter-method="showComList" clearable
                                                       placeholder="请输入"
                                                       :remote-method="showComList" @change="changeComlist">
                                                <el-option v-for="(item) in agentList"
                                                           :key="item.usercode"
                                                           :label="item.customerName1"
                                                           :value="item.usercode">
                                                </el-option>
                                            </el-select>
                                        </el-form-item>
                                        <el-form-item label="销售公司" required class="h-elformWrap-2">
                                            <brselect placeholder="请选择"
                                                      category="package_sales_group"
                                                      :v="f.companycode"
                                                      clearable
                                                      v-model="f.companycode">
                                            </brselect>
                                        </el-form-item>
                                        <el-form-item label="附件" v-if="showSence" class="h-elformWrap-2">
                                            <brupload
                                                    v-model="f.tcFileUrl"
                                                    :refid=bomId
                                                    reftype="TC_GC"
                                                    :limit="1"
                                                    :showtime="false"
                                                    uploadflag
                                                    delflag
                                                    @filecallback=mfIsUpload>
                                            </brupload>
                                        </el-form-item>
                                    </div>
                                </el-form>
                        </div>
                    </div>
                </div>
                <div class="n-hu ljjtablepaddings9" >
                    <div class="h-pieceTitle2">
                        <h1>套餐产品</h1>
                    </div>
                    <div class="h-table h-mrt30">
                        <el-table
                                ref="ddtable"
                                :data="bomDetailData"
                                style="width: 100%"
                                stripe
                                border
                                max-height="520"
                        >
                            <el-table-column
                                    type="index"
                                    width="40"
                                    label="#">
                            </el-table-column>
                            <el-table-column
                                    prop="prodcode"
                                    label="产品编码"
                                    width="120"
                            >
                                <template slot-scope="scope">
                                    <el-input class="h-tableInput" v-model.trim="scope.row.prodcode" style="height: 0.35rem;"
                                              placeholder="请输入" @change="selectDetailModel(scope.row)"></el-input>
                                </template>
                            </el-table-column>
                            <el-table-column
                                    prop="promodel"
                                    label="产品型号"
                                    width="120">
                                <template slot-scope="scope">
                                    <el-input class="h-tableInput" v-model="scope.row.promodel" style="height: 0.35rem;"
                                              placeholder="输入编码字段带出" disabled></el-input>
                                </template>
                            </el-table-column>
                            <el-table-column
                                    prop="proModelCode"
                                    label="产品大类"
                                    width="140">
                                <template slot-scope="scope">
                                    <el-select
                                            v-model="scope.row.proModelCode"
                                            placeholder="请选择"
                                            disabled
                                            filterable>
                                        <el-option
                                                v-for="(item,index) in productType"
                                                :key="index"
                                                :label="item.levelname"
                                                :value="item.id">
                                        </el-option>
                                    </el-select>
                                </template>
                            </el-table-column>
                            <el-table-column label="是否服务产品" prop="isFw" width="120">
                                <template slot-scope="scope">
                                    <el-select v-model="scope.row.isFw" :clearable="true"
                                               placeholder="请选择">
                                        <el-option label="是" value="1"></el-option>
                                        <el-option label="否" value="0"></el-option>
                                    </el-select>
                                </template>
                            </el-table-column>
                            <el-table-column
                                    prop="num"
                                    label="数量"
                                    width="80"
                            >
                                <template slot-scope="scope">
                                    <el-input class="h-tableInput" v-model="scope.row.num" style="height: 0.35rem;"
                                              placeholder="请输入" @change="getPackageTotalMonry(scope.row)" @input="handleNumberInput(scope.row)" ></el-input>
                                </template>
                            </el-table-column>
                            <el-table-column label="是否特价" v-if="showTj" prop="isTj" width="120">
                                <template slot-scope="scope">
                                    <el-select v-model="scope.row.isTj" :clearable="true" @change="getTejia(scope.row)"
                                               placeholder="请选择">
                                        <el-option label="是" value="1"></el-option>
                                        <el-option label="否" value="0"></el-option>
                                    </el-select>
                                </template>
                            </el-table-column>
                            <el-table-column label="特价版本" prop="tjid" v-if="showTj" width="140">
                                <template slot-scope="scope">
                                    <el-select class="h-tableInput" v-if="scope.row.isTj == 1" v-model="scope.row.tjid"
                                               @change="changeTejia($event,scope.row)"
                                               placeholder="请选择" clearable>
                                        <el-option
                                                v-for="item in scope.row.tjList"
                                                :key="item.tjid"
                                                :label="item.showname"
                                                :value="item.tjid">
                                        </el-option>
                                    </el-select>
                                </template>
                            </el-table-column>
                            <el-table-column
                                    prop="tjUsername"
                                    label="特价公司"
                                    :show-overflow-tooltip="true"
                                    v-if="showTj"
                                    width="120">
                            </el-table-column>
                            <el-table-column
                                    prop="proPrice"
                                    label="产品一级价"
                                    width="120"
                            >
                                <template slot-scope="scope">
                                    <el-input class="h-tableInput" v-model="scope.row.proPrice" style="height: 0.35rem;"
                                              placeholder="输入编码字段带出" disabled></el-input>
                                </template>
                            </el-table-column>
                            <el-table-column
                                    prop="finalPrice"
                                    label="成交价"
                                    width="120"
                            >
                                <template slot-scope="scope">
                                    <el-input class="h-tableInput" auto-complete="off" v-model="scope.row.finalPrice" :disabled="tjFlag"
                                              @change="getPackageTotalMonry(scope.row)" style="height: 0.35rem;"></el-input>
                                </template>
                            </el-table-column>
                            <el-table-column label="是否主品" prop="isMain" width="100" v-if="f.companycode == '44U0'">
                                <template slot-scope="scope">
                                    <el-select v-model="scope.row.isMain" :clearable="true"
                                               placeholder="请选择">
                                        <el-option label="是" value="1"></el-option>
                                        <el-option label="否" value="0"></el-option>
                                    </el-select>
                                </template>
                            </el-table-column>
                            <el-table-column
                                    min-width="150"
                                    prop="shareModelCode"
                                    :show-overflow-tooltip="true"
                                    label="共享大类">
                                <template slot-scope="scope">

                                    <el-select class="h-tableInput" v-if="scope.row.protype == 'OEM'&&scope.row.smList.length>0" v-model="scope.row.shareModelCode"
                                               @change="changeShareModel($event,scope.row)"
                                               placeholder="请选择" clearable>
                                        <el-option
                                                v-for="item in scope.row.smList"
                                                :key="item.shareModelCode"
                                                :label="item.shareModelName"
                                                :value="item.shareModelCode">
                                        </el-option>
                                    </el-select>
                                    <el-select class="h-tableInput" v-if="scope.row.protype != 'OEM'||scope.row.smList.length==0" v-model="scope.row.shareModelCode"
                                               @change="changeShareModel($event,scope.row)" disabled
                                               placeholder="请选择" clearable>

                                    </el-select>
                                    <!--<brselect :v="scope.row.shareModelCode"  v-if="scope.row.proType=='OEM'" style="width:1.5rem" category="product_level" v-model="scope.row.shareModelCode" @change="changeShareModel($event,scope.row)"
                                              clearable placeholder="&#45;&#45;请选择&#45;&#45;"></brselect>-->

                                </template>
                            </el-table-column>

                            <el-table-column
                                    label="操作"
                                    width="100"
                                    fixed="right">
                                <template slot-scope="scope">
                                    <el-button type="text" size="small"
                                               @click="delzhongbiao(scope.$index,scope.row)">删除
                                    </el-button>

                                </template>
                            </el-table-column>
                        </el-table>
                        <div class="h-tableAdd" @click="addBomDetail">
                            <a>新增</a>
                        </div>

                    </div>
                </div>

            </div>
        </div>
        <el-row style="display: flex;justify-content: center;margin: 30px 0;">
            <el-button class="h-btn h-bBtn h-bgwhite" @click="back">返回</el-button>
            <el-button class="h-btn h-bBtn h-bgblueQ2" @click="zancun()">暂存</el-button>
            <el-button class="h-btn h-bBtn h-bgblueQ2" @click="save()">确认提交</el-button>

        </el-row>

        <!--地址信息-->
        <areaSelect
                :visible.sync="showdizhiflag"
                v-if="showdizhiflag"
                @choseObj="choseDizhi"
        />

    </div>
</template>

<script>
    import ss from '../../api/SystemService'
    import big from 'big.js'

    export default {
        data() {
            return {
                f: {
                    bomDetailList:[],
                    lianqunCode:'',
                    lianqunName:'',
                    sceneCode:'',
                    sceneName:'',
                    childSceneCode:'',
                    childSceneName:'',
                    packageName:'',
                    taxCode:'',
                    startTime:'',
                    endTime:'',
                    isTj:null,
                    packagePrice:0,
                    isFl:null,
                    isWhole:null,
                    isStep:null,
                    shuilv:null,
                    isTransit:'0',
                    isSceneIncome:null,
                    isSingleSale:null,
                    phone:null,
                    address:null,
                    contactPerson:null,
                    tcUrl:null,
                    tcfileUrl:null,
                    bomId:null,
                    companycode:null,
                    isPolicy:null,
                    packageType:null,
                    agentCode: null,
                },
                agentCode:null,
                bomDetailData:[
                    {
                        prodcode:'',
                        promodel:'',
                        num:'',
                        proModelCode:'',
                        proPrice:'',
                        finalPrice:'',
                        isGx:0,
                        protype:'',
                        smList: [],
                        shareModelCode: '',
                        shareModelName: '',
                        taxRate:'',
                        isFw:'0',
                        isTj:'0',
                        isMain:'0',
                        tjUsercode:'',
                        tjUsername:'',
                        tjid: '',
                        tjList:[],
                        factory: '',
                    }
                ],

                options: [{
                    value: 'all',
                    label: '全选'
                }],
                rules: {
                    prodcode: [{required: true, message: '请填写产品编码', trigger: 'blur'}],
                    factory: [{required: true, message: '请选择产地名称', trigger: 'change'}],
                },
                sceneList:[],//场景
                productType: [],//大类list
                showTransit:false,
                showdizhiflag:false,
                bomId:null,
                tjFlag:false,
                showTj:false,
                showSence:false,
                showChildSence:false,
                taxList: [],
                agentList: [],
                isShouh:false,
            }
        },
        created() {
            this.selectProduct1();
            this.bomId = this.$util.getUuid();
            // this.changePackage();
            this.getTaxcodeList();
            if(this.$store.getters.hasRole('swyl_tc_shgly')){
                this.isShouh = true;
                this.f.packageType = '2';
                this.f.lianqunCode = 'SH';
                this.f.lianqunName = '售后';
            }
        },
        methods: {

            //返回
            back() {
                this.$router.push({path: "/chanp/productBom"});
            },
            //保存
            save() {

                if(this.showChildSence && this.f.childSceneCode){
                    this.f.childSceneName = this.$store.getters.dictname("package_lk_childScene",this.f.childSceneCode);
                }
                this.f.submitFlag = '提交';
                var subflag = false;
                var subflag1 = false;
                var fwFlag = false;
                var comFlag = false;
                var tjFlag = false;
                var tjFlag1 = false;
                var tjFlag2 = false;
                this.$refs['f'].validate((valid) => {
                    if (valid) {
                        subflag = true;
                    } else {
                        this.$msg.msge("请完善信息后再提交！");
                        return false;
                    }
                });

                if (this.f.taxCode.length != 18 && this.f.taxCode.length != 19) {
                    this.$msg.msge("税码长度不正确！");
                    return false;
                }

                if (this.f.packageType == null || this.f.packageType == '') {
                    this.$msg.msge("套餐类型不能为空！");
                    return false;
                }

                if (this.f.companycode == null || this.f.companycode == '') {
                    this.$msg.msge("销售公司不能为空！");
                    return false;
                }
                //如果是冷库场景判断是否选择子场景
                if (this.f.sceneCode == 'ALL001' && (this.f.childSceneCode == null || this.f.childSceneCode == '')) {
                    this.$msg.msge("冷库场景请选择子场景！");
                    return false;
                }

                if (this.bomDetailData.length < 1) {
                    this.$msg.msge("请至少选择一个产品");
                    return false;
                }

                if(this.showTj && (this.f.agentCode == null || this.f.agentCode == "")){
                  this.$msg.msge("指定经销商不能为空！");
                  return;
                }

                var taxRate = this.bomDetailData[0].taxRate;
                //校验子件必填
                var isFw = this.bomDetailData[0].isFw;
                for (var i = 0; i < this.bomDetailData.length; i++) {
                    var bom = this.bomDetailData[i];
                    if (!this.bomDetailData[i].prodcode) {
                        this.$msg.msge("请填写产品编码");
                        subflag1 = false;
                        return false;
                    }
                    if (!this.bomDetailData[i].num) {
                        this.$msg.msge("请填写产品数量");
                        subflag1 = false;
                        return false;
                    }
                    if (!this.bomDetailData[i].finalPrice) {
                        this.$msg.msge("请填写成交价");
                        subflag1 = false;
                        return false;
                    }
                    if (isFw != this.bomDetailData[i].isFw) {
                        fwFlag = true;
                    }
                    if (this.f.packageType == '1') {
                        //是否特价不能为空
                        if (bom.isTj == '' || bom.isTj == null) {
                            tjFlag = true;
                        } else {
                            if (bom.isTj == 1) {
                                //如果是特价，则特价版本号不能为空
                                if (bom.tjid == null || bom.tjid == '') {
                                    tjFlag1 = true;
                                }
                            } else if (bom.isTj == 0) {
                                //如果不是特价，则成交价必须小于等于一级价格
                                if (bom.finalPrice < bom.proPrice) {
                                    tjFlag2 = true;
                                }
                            }
                        }
                        //定制套餐，套餐有效期限制
                        if(this.$store.getters.hasRole('swyl_tc_zdhgly')){
                            var dateFlag = this.completeDate(new Date(this.f.startTime),new Date(this.f.endTime),6);
                            if(!dateFlag){
                                this.$msg.msge("自动化套餐有效期不能超过六个月");
                                subflag1 = false;
                                return false;
                            }
                        }else {
                            var dateFlag = this.completeDate(new Date(this.f.startTime),new Date(this.f.endTime),3);
                            if(!dateFlag){
                                this.$msg.msge("定制套餐有效期不能超过三个月");
                                subflag1 = false;
                                return false;
                            }
                        }
                    }

                }
                if (tjFlag) {
                    this.$msg.msge("是否特价不能为空！");
                    return;
                }
                if (tjFlag1) {
                    this.$msg.msge("特价版本号不能为空！");
                    return;
                }
                if (tjFlag2 &&  this.f.sceneName != '自产冷库场景') {
                    this.$msg.msge("定制套餐非特价产品成交价不能小于一级价！");
                    return;
                }
                subflag1 = true;
                this.f.bomDetailList = this.bomDetailData;
                if (this.bomId) {
                    this.f.bomId = this.bomId;
                }
                if (subflag && subflag1) {
                    if (fwFlag) {
                        this.$confirm('套餐内所有产品税率一致,此套餐包含服务产品, 请确认税率！', '提示', {
                            confirmButtonText: '确定',
                            cancelButtonText: '取消',
                            type: 'warning'
                        }).then(() => {
                            ss.bom.save(this.f).then(rd => {
                                this.$router.push({path: "/chanp/productBom"});
                            })
                        }).catch(() => {
                            this.$message({
                                type: 'info',
                                message: '已取消'
                            });
                        });
                    } else {
                        this.$msg.confirm("确认提交该信息?", () => {
                            ss.bom.save(this.f).then(rd => {
                                this.$router.push({path: "/chanp/productBom"});
                            })
                        });
                    }
                }
            },
            //暂存
            zancun(){
                this.f.bomDetailList = this.bomDetailData;
                if(this.showChildSence && this.f.childSceneCode){
                    this.f.childSceneName = this.$store.getters.dictname("package_lk_childScene",this.f.childSceneCode);
                }

                ss.bom.zancun(this.f).then(rd => {
                    this.$msg.msgs(rd.msg);
                })
            },
            //查询主bom信息
            selectMainModel(code) {
                let query = {
                  materialid :code,
                  packageType:this.f.packageType,
                  agentCode:this.f.agentCode
                }
                ss.bom.selectByCode(query).then(rd => {
                    if (rd) {
                        this.f.promodel = rd.materialDescrition;
                        this.f.unit = rd.primaryUom;
                    }
                })
            },
            //查询子bom信息
            selectDetailModel(v) {
              let query = {
                materialid :v.prodcode,
                packageType:this.f.packageType,
                agentCode:this.f.agentCode
              }
                ss.bom.selectByCode(query).then(rd => {
                    if (rd) {
                        v.promodel = rd.materialName;
                        v.proPrice = rd.value;
                        v.proModelCode = rd.materialLevelCode;
                        v.finalPrice = rd.value;
                        v.isGx = rd.isGx;
                        v.protype = rd.protype;
                        if (rd.smList) {
                            v.smList = rd.smList;
                        }
                        v.taxRate = rd.taxRate;
                        v.companycode = rd.companycode;
                        v.factory = rd.factory;
                       if( v.prodcode.startsWith('HAIER')){ //服务产品默认服务产品
                           v.isFw = '1';
                       }
                    }
                })
            },

            //删除子件信息
            delzhongbiao(v, row) {
                this.bomDetailData.splice(v, 1);
                var proPrice = new big(row.finalPrice).times(new big(row.num)).toFixed(2);
                this.f.packagePrice = this.f.packagePrice - proPrice;
            },
            // 添加子件信息
            addBomDetail() {
                var data = {
                    prodcode: '',
                    promodel: '',
                    num: '',
                    proModelCode: '',
                    proPrice: '',
                    finalPrice: '',
                    isGx: 0,
                    protype: '',
                    smList: [],
                    shareModelCode: '',
                    shareModelName: '',
                    isFw: '0',
                    taxRate: '',
                    companycode: '',
                    isTj: '0',
                    tjUsercode: '',
                    tjUsername: '',
                    tjid: '',
                    tjList: [],
                    factory: '',
                }
                this.bomDetailData.push(data)
            },
            //获取场景信息
            getSceneList() {
                ss.bom.getSceneList(this.f).then(rd => {
                    this.sceneList = rd.msg;
                });
            },
            getPackageTotalMonry(v) {
                /*                var packagePrice = this.f.packagePrice
                if(!v.finalPrice){
                    this.f.finalPrice = v.proPrice;
                    this.f.packagePrice = packagePrice;
                }else {
                    this.f.packagePrice = v.finalPrice * v.num + this.f.packagePrice;
                }*/
                var packagePrice = new big(0);
                for (var i = 0; i < this.bomDetailData.length; i++) {
                    var tc = this.bomDetailData[i];

                    if (tc.finalPrice && tc.num) {
                        packagePrice = new big(packagePrice).plus(new big(tc.finalPrice).times(new big(tc.num))).toFixed(2);
                    }
                }
                this.f.packagePrice = packagePrice;

            },
            //获取产品大类信息
            //产品大类下拉框
            selectProduct1() {
                ss.ProService.product1Select().then(rd => {
                    this.productType = rd;
                })
            },
            changeTransit() {
                if (this.f.isTransit == 1) {
                    this.showTransit = true;
                } else if (this.f.isTransit == 0) {
                    this.showTransit = false;
                    this.f.address = '';
                    this.f.phone = '';
                    this.f.contactPerson = '';
                }
            },
            //获取地址
            selectAreadialog() {
                this.showdizhiflag = true;
            },
            choseDizhi(obj) {

                this.f.address = obj.quobj.namepath;

                this.f.address = this.f.address + "##" + obj.addrdetail;

                this.showdizhiflag = false;

                this.openReceivedTimedisabled = false;

            },
            //修改共享大类
            changeShareModel(scode, row) {
                if (row.shareModelCode) {
                    const smobj = _.find(row.smList, {shareModelCode: row.shareModelCode})
                    row.shareModelName = smobj.shareModelName;
                    row.shareModelCode = smobj.shareModelCode;
                } else {
                    row.shareModelName = null;
                }
            },
            mfIsUpload(v) {
                console.log('mfIsUpload', v)
                if (v.length > 0) {
                    //this.order.fileUrl = v[0].saveurl;
                    let arrnew = []
                    v.forEach(e => {
                        this.f.tcfileUrl = e.saveurl
                        this.tcUrl = e.saveurl
                    })
                    // this.order.mffileUrl = arrnew
                } else {
                    this.f.tcfileUrl = null;
                }
            },
            getTejia(v) {
                if (v.isTj == 1) {
                    this.tjFlag = true;
                    var data = {
                        prodcode:null,
                        tjUsercode:null
                    }
                    if(v.prodcode == null || v.prodcode == ""){
                        this.$msg.msge("产品编码不能为空！");
                        return;
                    }
                    if(this.f.agentCode == null || this.f.agentCode == ""){
                        this.$msg.msge("指定经销商不能为空！");
                        return;
                    }
                    data.prodcode = v.prodcode;
                    data.tjUsercode = this.f.agentCode;
                    ss.bom.getTejiaList(data).then(rd => {
                        v.tjList = rd.obj.tjList;
                    });
                } else {
                    v.tjUsername = null;
                    v.tjUsercode = null;
                    v.tjList = [];
                    this.tjFlag = false;
                }
            },
            //修改特价公司以及成交价
            changeTejia(scode, row) {
                if (row.tjid) {
                    const tj = _.find(row.tjList, {tjid: row.tjid})
                    row.tjUsername = tj.username;
                    row.tjUsercode = tj.user_code;
                    row.finalPrice = tj.tejia;
                    this.getPackageTotalMonry(row);
                    // row.shareModelCode = smobj.shareModelCode;
                } else {
                    row.tjUsername = null;
                    row.tjUsercode = null;
                    row.finalPrice = 0;
                    this.getPackageTotalMonry(row);
                }
            },
            //修改是否政策
            /*changePolicy(){
                if(this.f.isPolicy == '1'){
                    //是政策套餐，走原有流程
                    this.showTj = false;
                    this.f.isTj = '0';
                    this.bomDetailData = [
                        {
                            prodcode:'',
                            promodel:'',
                            num:'',
                            proModelCode:'',
                            proPrice:'',
                            finalPrice:'',
                            isGx:0,
                            protype:'',
                            smList: [],
                            shareModelCode: '',
                            shareModelName: '',
                            taxRate:'',
                            isFw:'0',
                            companycode:'',
                            isTj:'0',
                            tjUsercode:'',
                            tjUsername:'',
                            tjid: '',
                            tjList:[],
                        }
                    ]
                }else if(this.f.isPolicy == '0'){
                    //不是，走新流程
                    this.showTj = true;
                    this.f.isTj = '0';
                }
            },*/
            changePackage() {
                this.showChildSence = false;

                //定制套餐，根据创建订单的角色自动带出对应场景（目前只有云眼、样本、自动化）
                if (this.f.packageType == '1') {
                    var sDate = new Date();
                    this.f.startTime = new Date();
                    this.showSence = true;
                    //根据当前人员登录角色获取对应场景（不可修改）
                    if (this.$store.getters.hasRole('swyl_tc_ybgly_create')) {
                        this.f.sceneCode = 'X02001';
                        this.f.sceneName = '样本库方案场景';
                        //套餐有效期默认三个月
                        sDate.setMonth(sDate.getMonth() + 3)
                        this.f.endTime = this.timestampToTime(sDate);
                    } else if (this.$store.getters.hasRole('swyl_tc_yygly_create')) {
                        this.f.sceneCode = 'X08001';
                        this.f.sceneName = '智慧实验室场景';
                        //套餐有效期默认三个月
                        sDate.setMonth(sDate.getMonth() + 3)
                        this.f.endTime = this.timestampToTime(sDate);
                    } else if (this.$store.getters.hasRole('swyl_tc_zdhgly_create')) {
                        this.f.sceneCode = 'X02002';
                        this.f.sceneName = '自动化大项目场景';
                        //套餐有效期默认六个月
                        sDate.setMonth(sDate.getMonth() + 6)
                        this.f.endTime = this.timestampToTime(sDate);
                    }else if (this.$store.getters.hasRole('swyl_tc_zclkgly')) {
                        this.f.sceneCode = 'ALL001';
                        this.f.sceneName = '自产冷库场景';
                        this.showChildSence = true;
                    }else {
                        //其余定制套餐默认三个月
                        sDate.setMonth(sDate.getMonth() + 3)
                        this.f.endTime = this.timestampToTime(sDate);
                    }
                    this.showTj = true;
                    //如果经销商是金卫信切换套餐类型
                  if(this.agentCode == '9100001439'){
                    this.bomDetailData = [
                      {
                        prodcode:'',
                        promodel:'',
                        num:'',
                        proModelCode:'',
                        proPrice:'',
                        finalPrice:'',
                        isGx:0,
                        protype:'',
                        smList: [],
                        shareModelCode: '',
                        shareModelName: '',
                        taxRate:'',
                        isFw:'0',
                        companycode:'',
                        isTj:'0',
                        tjUsercode:'',
                        tjUsername:'',
                        tjid: '',
                        tjList:[],
                        factory: '',
                      }]
                  }
                } else if (this.f.packageType == '2') {
                    this.showTj = false;
                    this.showSence = false;
                    this.f.sceneCode = '';
                    this.f.sceneName = '';
                    this.f.childSceneCode='';
                    this.f.childSceneName='';
                }
            },
            getTaxcodeList(value) {
                var data = {
                    taxcodeLike: null,
                };
                data.taxcodeLike = value;
                ss.bom.getTaxcodeList(data).then(rd => {
                    this.taxList = rd.msg;
                });
            },
            // 时间戳转换日期
            timestampToTime(timestamp) {
                var  date = new Date(timestamp); //时间戳为10位需*1000，时间戳为13位的话不需乘1000
                let Y = date.getFullYear() ;
                let M = (date.getMonth()+1 < 10 ?  '0' +(date.getMonth()+1) : date.getMonth()+1) ;
                let D = date.getDate().toString().padStart(2,0);
                let h = date.getHours() +  ':' ;
                let m = date.getMinutes() +  ':' ;
                let s = date.getSeconds();
                return  Y + '-' + M + '-' + D;//+h+m+s
            },
            //获取指定经销商
            showComList(value) {
                ss.netApi.selectOnlyName(value).then(res => {
                    this.agentList = res.obj
                })
            },
            changeComlist(value){
              //如果是金卫信或者选择的是金卫信重置产品列表
              if(this.agentCode == '9100001439' || value == '9100001439'){
                this.bomDetailData = [
                  {
                    prodcode:'',
                    promodel:'',
                    num:'',
                    proModelCode:'',
                    proPrice:'',
                    finalPrice:'',
                    isGx:0,
                    protype:'',
                    smList: [],
                    shareModelCode: '',
                    shareModelName: '',
                    taxRate:'',
                    isFw:'0',
                    companycode:'',
                    isTj:'0',
                    tjUsercode:'',
                    tjUsername:'',
                    tjid: '',
                    tjList:[],
                    factory: '',
                  }]
              }
              this.agentCode = value;
            },
            completeDate (time1, time2, m) {
                const year1 = time1.getFullYear()
                const year2 = time2.getFullYear()
                const month1 = time1.getMonth() + 1
                const month2 = time2.getMonth() + 1
                const day1 = time1.getDate()
                const day2 = time2.getDate()
                if (year2 === year1) { // 判断两个日期 是否是同年
                    if (month2 - month1 > m) { // 相差是否 在m个月中
                        return false
                    } else if (month2 - month1 === m) { // 如果正好为 m月 判断天数
                        if (day2 > day1) {
                            return false
                        }
                    }
                } else { // 不同年
                    if (year2 - year1 > 1) {
                        return false
                    }
                    else if (year2 - year1 === 1) {
                        if (month2 > m || month1 + m - month2 < 12) {
                            return false
                        }
                        else if (month1 + m - month2 === 12) { // 正好为m月 判断天数
                            if (day2 > day1) {
                                return false
                            }
                        }
                    }
                }
                return true
            },
            // 限制最多3位小数
            handleNumberInput(row) {
                let value = row.num;

                // 第一步：只保留数字和一个小数点
                value = value.replace(/[^\d.]/g, '');
                value = value.replace(/^\./g, '0.'); // 开头是.自动补0
                value = value.replace(/\.{2,}/g, '.'); // 多个.只保留一个

                // 第二步：限制最多3位小数
                const decimalIndex = value.indexOf('.');
                if (decimalIndex !== -1) {
                    value = value.substring(0, decimalIndex + 4);
                }

                // 赋值回去
                row.num = value;
            },
        }
    }
</script>
<style>
    .Bianji .h-elformWrap-2 .el-form-item__label {
        width: 26%;
        text-align: right;
    }
    .Bianji .h-elformWrap-2 .el-form-item__content {
        width: 74%;
    }
    .Bianji .h-elformWrap-1 .el-form-item__label {
        width: 8%;
        text-align: right;
    }
    .Bianji .h-elformWrap-1 .el-form-item__content {
        width: 92%;
    }
    .Bianji .h-elformWrap-2 {
        width: 33.333% !important;
        padding-right: 0.5rem
    }
    .Bianji .h-elformWrap-1 {
        width: 100%;
        padding-right: 0.5rem
    }
    .w-elformWrap .el-form-item__label {
        width: 10% !important;
    }
    .w-elformWrap .el-form-item__content {
        width: 90% !important;
    }
    .ljjtablepaddings9 .h-tableInput .el-input__inner{
        padding: 0.05rem 0.1rem;
    }
    .ljjtablepaddings9 .h-tableInput .el-input__icon{
        line-height: 0.25rem;
    }
    .bigDiv {
        margin: 20px;
    }
    .bigDiv .h-piece .top .ccc {
        margin-top: -13px;
    }

    .h-rowCon1 {
        padding-top: 0.22rem;
        padding-bottom: 0rem;
        font-size: 16px;
        position: relative;
    }
</style>
